export default __webpack_public_path__ + "static/media/settings-user.447895b8.svg";